// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://asrkgtsboqenyuetcjuj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFzcmtndHNib3Flbnl1ZXRjanVqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY4NjY0NjQsImV4cCI6MjA3MjQ0MjQ2NH0.IbmQpxyInbEBlRU_3kd-vdiHmlw7tgbhEk3j7LRpCck";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});